export default __webpack_public_path__ + "static/media/03_Business-PortraitArchitecture-Interior-EschweilerPhotography__M1A7320.0a61967e.jpg";